import { FC, useCallback, useEffect } from 'react';
import { JazzClient } from '@salutejs/jazz-sdk-web';
import { useClientsContext } from '../../../../shared/contexts/clientsContext';
import { useGlobalContext } from '../../../../shared/contexts/globalContext';

export type UserProfileProps = {
  client: JazzClient;
};

export const UserProfile: FC<UserProfileProps> = ({ client }) => {
  const { eventBus } = useGlobalContext();
  const { loginBySdkToken } = useClientsContext();

  // Токен и имя пользователя
  const sdkToken = sessionStorage.getItem("meetmindJazzToken") || "";
  const value = sdkToken;
  const userName = sessionStorage.getItem("meetmindJazzUserName") || "";

  // Функция для закрытия окна (здесь она не нужна, но оставляем для целостности логики)
  const handleClose = useCallback(() => {
    console.log('Authorization process is complete.');
  }, []);

  // Логика авторизации
  const handleLoginBySdkToken = useCallback(() => {
    const newUserName = userName || 'MyUserName';
    const sub = newUserName;
    const iss = 'MeetmindApp';

    client.auth.loginBySdkToken(sdkToken)
      .then(async (success) => {
        if (!success) {
          eventBus({
            type: 'error',
            payload: { title: 'Error login by SDK Secret' },
          });
          return;
        }

        console.log("User " + userName + " is authorized");

        loginBySdkToken(client, { iss, sub, userName, value });
        sessionStorage.setItem('JAZZ_VALUE', sdkToken);

        handleClose();
      })
      .catch((error) => {
        console.error(error);
        eventBus({
          type: 'error',
          payload: { title: 'Error login by SDK Secret' },
        });
      });
  }, [client, sdkToken, handleClose, userName, eventBus, loginBySdkToken, value]);

  // useEffect для вызова handleLoginBySdkToken один раз при монтировании компонента
  useEffect(() => {
    handleLoginBySdkToken();
  }, [handleLoginBySdkToken]);

  // Компонент не рендерит ничего
  return null;
};